import _ from "lodash";
import { CompanyContact } from "./CompanyContact";
import { Entity } from "./Entity.abstract";

export class CompanyContacts extends Entity {
    constructor({ _id, name, status, contacts, createdAt }) {
        super({ _id, name, status, contacts, createdAt });
        this.props.isCompany = true;
        this.setContactsEntity();
    }

    removeContactsWithoutNPS() {
        this.props.contacts = this.props.contacts.filter((contact) => {
            return contact.props.relations?.nps?.status;
        });
    }

    setContactsEntity() {
        if (!this.props.contacts?.length) return;
        const contacts = this.props.contacts.map((contact) => {
            contact.companyId = this.getId();
            return CompanyContact.restore(contact);
        });
        this.setContacts(contacts);
    }

    getSizeContacts() {
        return this.props.contacts?.length > 1 ||
            this.props.contacts?.length === 0
            ? `${this.props.contacts.length} cadastros`
            : `${this.props.contacts.length} cadastro`;
    }

    getSizeRelationsAccessString(relation) {
        const relationSize = this.getSizeRelationsAccess(relation);
        return relationSize > 1 || relationSize === 0
            ? `${relationSize} acessos`
            : `${relationSize} acesso`;
    }

    getSizeRelationsAccess(relation) {
        const relationFilter = this.props.contacts.filter((contact) =>
            _.get(contact, `props.relations.${relation}`)
        );
        return relationFilter.length;
    }

    getCompanyProps() {
        return {
            _id: this.props._id,
            name: this.props.name,
            status: this.props.status
        };
    }

    getContacts() {
        return this.props.contacts || [];
    }

    transformRelationsToBool() {
        const { contacts } = this.props;
        contacts.forEach((contact) => {
            contact.transformRelationsToBool();
        });
    }

    removeAllContacts() {
        this.props.contacts = [];
    }

    removeContactById(contactId) {
        if (this.props?.contacts) {
            _.remove(this.props.contacts, (item) => {
                return item.props._id === contactId;
            });
        }
    }

    getContactsIds() {
        return this.props.contacts.map((contact) => contact.props._id);
    }

    getRecommendations() {
        const recommendations = this.getAllRatings().reduce((acc, rating) => {
            if (rating?.props.recommendations) {
                const recomme = rating.props.recommendations.map((r) => {
                    return {
                        ...r,
                        companyName: rating.props.companyName,
                        contactName: rating.props.name,
                        answered: rating.props.events?.answered
                    };
                });
                acc.push(...recomme);
            }
            return acc;
        }, []);
        return recommendations;
    }

    getTotalRecommendationsLabel() {
        const total = this.getTotalRecommendations();
        if (!total) return "N/A";
        return `${total} ${total === 1 ? "indicação" : "indicações"} `;
    }

    getTotalRecommendations() {
        if (!this.props?.contacts?.length) return 0;
        const total = this.props.contacts.reduce((acc, conctact) => {
            let totalRecommendations = 0;
            if (conctact.props.rating) {
                totalRecommendations = conctact.props.rating.getTotalRecommendations();
            }
            return totalRecommendations + acc;
        }, 0);
        return total;
    }

    getLastScoreReaction() {
        if (!this.props?.contacts?.length) return "N/A";
        const ratings = this.getAllRatings();
        if (!ratings?.length) return "N/A";
        const ratingsOrdered = _.sortBy(ratings, (rating) => {
            if (!rating.props.events?.answered) return -1;
            return rating.props.events?.answered;
        });
        const last = _.last(ratingsOrdered);
        return last.getScoreReaction();
    }

    getLastAnsweredInfo() {
        if (!this.props?.contacts?.length) return "";
        const ratings = this.getAllRatings();
        if (!ratings?.length) return "";
        const ratingsOrdered = _.sortBy(ratings, (rating) => {
            if (!rating.props.events?.answered) return -1;
            return rating.props.events?.answered;
        });
        const ratingsAnswered = ratingsOrdered.filter(
            (rating) => rating.props.events?.answered
        );
        if (!ratingsAnswered) return "";
        const last = _.last(ratingsAnswered);
        return `Última Resposta: ${last.getAnsweredInfo()}`;
    }

    getTotalComments() {
        if (!this.props?.contacts?.length) return "N/A";
        const ratings = this.getAllRatings();
        if (!ratings?.length) return "N/A";
        const ratingsWithCommments = ratings.filter((rating) => {
            return rating.props.comment;
        });
        if (ratingsWithCommments.length > 0)
            return `${ratingsWithCommments.length} ${
                ratingsWithCommments.length === 1 ? "comentário" : "comentários"
            } `;
        return "N/A";
    }

    getTotalsEvents() {
        const ratings = this.getAllRatings();
        if (!ratings?.length) return `0 enviados | 0 respostas`;
        const events = { answered: "", sent: "" };
        const sents = ratings.filter((rating) => rating.props.events.sent);
        events.sent = `${sents?.length} ${
            sents?.length === 1 ? "enviado" : "enviados"
        }`;
        const answereds = ratings.filter(
            (rating) => rating.props.events.answered
        );
        events.answered = `${answereds?.length} ${
            answereds?.length === 1 ? "resposta" : "respostas"
        }`;
        return `${events.sent} | ${events.answered}`;
    }

    updateRatingsEventSent() {
        this.props.contacts.forEach((contact) => {
            if (contact.props.rating) contact.props.rating.updateEventSent();
            else contact.createFirstRating();
        });
    }

    getAllRatings() {
        const ratings = [];
        this.props.contacts.forEach((contact) => {
            if (contact.props.rating) ratings.push(contact.props.rating);
        });
        return ratings;
    }

    getContactsByScoreType(whichType) {
        return this.props.contacts.filter((contact) => {
            return contact.isRatingScoreType(whichType);
        });
    }

    getContactsReceivedRating() {
        return this.props.contacts.filter((contact) => {
            return contact.receivedRating();
        });
    }

    getContactsNotAnsweredRating() {
        return this.props.contacts.filter((contact) => {
            return !contact.answeredRating();
        });
    }

    getContactsNotSentRating() {
        return this.props.contacts.filter((contact) => {
            return contact.notSentRating();
        });
    }

    setContacts(contacts) {
        this.props.contacts = contacts;
    }

    getRatingsAnswered() {
        if (!this.props.contacts?.length) return [];
        const ratings = [];
        this.props.contacts.forEach((contact) => {
            if (contact.answeredRating()) ratings.push(contact.props.rating);
        });
        return ratings;
    }

    allContactsInNPS() {
        if (!this.props.contacts?.length) return false;
        return this.props.contacts.every((contact) => {
            return contact.props.relations?.nps?.status;
        });
    }

    changeNPSForAllContacts(status) {
        this.props.contacts.forEach((contact) => {
            contact.setRelationStatus("nps.status", status);
        });
    }

    hasAnyContactInNPS() {
        return this.props.contacts.some((contact) => {
            return contact.props.relations?.nps?.status;
        });
    }

    getCountanswersWhatsapp() {
        return this.props.contacts.filter((contact) =>
            ["APPROVED", "REJECTED"].includes(
                contact.props?.consentWhatsapp?.status
            )
        ).length;
    }
}
